import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal } from "../Reveal";
import { PAGES } from "../../config/pages";

export const ProjectInfo = ({ title, chapters, internalSlugs, pagesSource = PAGES }) => (
  <section className="bg-ink-bg py-24 sm:py-32" data-testid="project-info-section">
    <div className="mx-auto max-w-6xl px-6">
      <Reveal>
        <p className="font-mono text-xs uppercase tracking-[0.35em] text-accent">Field Guide</p>
        <h2 className="mt-4 max-w-3xl font-display text-3xl uppercase leading-none tracking-tight text-ink-text sm:text-4xl lg:text-5xl">
          {title}
        </h2>
      </Reveal>

      <div className="mt-16 space-y-16">
        {chapters.map((chapter, i) => (
          <Reveal key={i} delay={0.05}>
            <div className="grid gap-8 border-t border-ink-line pt-10 md:grid-cols-[200px_1fr]" data-testid={`project-chapter-${i + 1}`}>
              <span className="font-mono text-sm uppercase tracking-[0.3em] text-accent">
                CH.{String(i + 1).padStart(2, "0")}
              </span>
              <div className="max-w-3xl">
                <h3 className="text-xl font-bold tracking-tight text-ink-text sm:text-2xl">{chapter.heading}</h3>
                <p className="mt-4 leading-relaxed text-ink-muted">{chapter.body}</p>
                <ul className="mt-6 space-y-2.5">
                  {chapter.points.map((point, j) => (
                    <li key={j} className="flex items-start gap-3 font-mono text-sm text-ink-text">
                      <span className="mt-1.5 h-2 w-2 shrink-0 bg-accent" />
                      {point}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </Reveal>
        ))}
      </div>

      {internalSlugs && internalSlugs.length > 0 && (
        <Reveal>
          <div className="mt-20 border border-ink-line bg-ink-surface p-8 sm:p-10" data-testid="internal-links-block">
            <p className="font-mono text-xs uppercase tracking-[0.3em] text-accent">Keep calculating</p>
            <div className="mt-6 flex flex-wrap gap-x-10 gap-y-4">
              {internalSlugs.map((slug) => {
                const page = pagesSource[slug];
                if (!page) return null;
                return (
                  <Link
                    key={slug}
                    to={`/${slug}`}
                    data-testid={`internal-link-${slug}`}
                    className="group inline-flex items-center gap-2 font-mono text-sm uppercase tracking-[0.15em] text-ink-text transition-colors duration-200 hover:text-accent"
                  >
                    {page.calculator.name}
                    <ArrowRight className="h-4 w-4 text-accent transition-transform duration-300 group-hover:translate-x-1" />
                  </Link>
                );
              })}
            </div>
          </div>
        </Reveal>
      )}
    </div>
  </section>
);
